import Availabilities from './Availabilities';

export default Availabilities;


// WEBPACK FOOTER //
// ./src/components/Query/Availabilities/index.ts